import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React, {ReactNode, useCallback, useState} from 'react';
import LoadingButton from '../LoadingIndicator/LoadingButton';

const useStyles = makeStyles(theme => ({
    cancel: {
        color: theme.palette.grey['500'],
    },
}));

type Props = {
    open : boolean;
    title : string;
    message : ReactNode;
    onClose : () => void;
    onConfirm : () => void;
    noUpdateAfterConfirm ?: boolean;
};

const ConfirmationDialog : React.FC<Props> = ({
    open,
    title,
    message,
    onClose,
    onConfirm,
    noUpdateAfterConfirm
} : Props) => {
    const classes = useStyles();
    const [confirming, setConfirming] = useState(false);

    const handleConfirm = useCallback(async () => {
        setConfirming(true);

        try {
            await onConfirm();
        } finally {
            if (!noUpdateAfterConfirm) {
                setConfirming(false);
                onClose();
            }
        }
    }, [onConfirm, onClose, setConfirming, noUpdateAfterConfirm]);

    return (
        <Dialog
            open={open}
            onClose={(_event, reason) => {
                if(reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                    onClose();
                }
            }}
            disableEscapeKeyDown={confirming}
            maxWidth="xs"
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    autoFocus
                    onClick={onClose}
                    disabled={confirming}
                    className={classes.cancel}
                >
                    Cancel
                </Button>
                <LoadingButton
                    onClick={handleConfirm}
                    color="primary"
                    disabled={confirming}
                    loading={confirming}
                >
                    Okay
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;
